import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetIncidentUpdateRequestDetailsAsync,
  IIncidentUpdateRequestDetails,
} from "../../api/Incident/IIncidentUpdateRequestDetails";
import { RootState } from "../store";

export interface IncidentUpdateRequestState {
  fetchStatus: string;
  incidentUpdatRequest?: IIncidentUpdateRequestDetails;
}

const initialState: IncidentUpdateRequestState = {
  fetchStatus: "Loading...",
  incidentUpdatRequest: undefined,
};

export const loadIncidentUpdateRequestAsync = createAsyncThunk(
  "incidentUpdateRequest/load",
  async (incidentUpdateRequestId: string) => {
    const response = await GetIncidentUpdateRequestDetailsAsync(
      incidentUpdateRequestId
    );
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const incidentUpdateRequestSlice = createSlice({
  name: "incidentUpdateRequest",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadIncidentUpdateRequestAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadIncidentUpdateRequestAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.incidentUpdatRequest = action.payload;
      });
  },
});

export const selectIncidentUpdateRequest = (state: RootState) =>
  state.incidentUpdateRequest;

export default incidentUpdateRequestSlice.reducer;
